export default {
    resetFocusedOtherRollupDatapoint: {
        datapoint: {
            name: 'TnS_ResetFocusedOtherRollup',
            customData: function (focusedViewFilter, actionSource) { return [
                actionSource,
                focusedViewFilter,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map